import { useMutation, useQueryClient } from "@tanstack/react-query";
import firmwareKlydosClient, {
  CreateFirmwareKlydosPayload,
} from "../../../api/firmware-klydos";

const useCreateFirmwareKlydosMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["firmware-klydos", "create"],
    mutationFn: (payload: CreateFirmwareKlydosPayload) =>
      firmwareKlydosClient.createFirmwareKlydos(payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["firmware-klydos"] }),
  });
};

export default useCreateFirmwareKlydosMutation;
